var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia, ui, layout, V, elementTools, util } from '@joint/plus';
import { DurationNumberInput } from './highlighters/duration-number-input';
import { DurationHandle } from './tools/duration-handle';
import { TaskElement, TaskElementView } from './shapes/task-element';
import { BottomElement } from './shapes/bottom-element';
var Yamazumi3D = /** @class */ (function () {
    function Yamazumi3D(options) {
        var _this = this;
        this.topLeft = options.topLeft;
        this.operators = options.operators;
        this.paper = options.paper;
        this.height = options.height;
        this.maxDuration = options.maxDuration || 60;
        this.minDuration = options.minDuration || 4;
        this.taskWidth = options.taskWidth || 200;
        this.taskDepth = options.taskDepth || 20;
        this.taktColor = '#ED2637';
        this.operationGap = 10;
        this.durationHeight = (this.height - this.taskDepth) / this.maxDuration;
        this.topY = this.topLeft.y + this.height - this.maxDuration * (this.durationHeight) - this.taskDepth;
        this.legendOffset = 15;
        this.createOperators();
        var layoutOptions = {
            direction: layout.StackLayout.Directions.BottomTop,
            bottomLeft: {
                x: this.topLeft.x,
                y: this.topLeft.y + this.height
            },
            stackCount: this.operators.length,
            stackSize: this.taskWidth,
            stackGap: this.operationGap,
            stackElementGap: 0,
            setAttributes: function (el, _a) {
                var position = _a.position;
                el.set({
                    position: position,
                    // Don't show animation when disableAnimation is set
                    animation: _this.paper.model.get('animationDisabled') ? false : (position.x === el.position().x)
                });
            }
        };
        this.layoutView = new ui.StackLayoutView({
            layoutOptions: layoutOptions,
            paper: this.paper,
            canInteract: function (elementView) {
                return elementView instanceof TaskElementView;
            },
            preview: function (data, view) {
                var targetStack = data.targetStack, invalid = data.invalid;
                var size = targetStack.bbox.width - view.model.get('stackGap') - 10;
                var color = '#43D200';
                var layerNode = _this.paper.getLayerView(dia.Paper.Layers.BACK).el;
                if (_this.invalidDurationElement) {
                    _this.invalidDurationElement.remove();
                    delete _this.invalidDurationElement;
                }
                if (invalid) {
                    color = 'red';
                    _this.invalidDurationElement = V(/* xml */ "\n                    <g transform=\"translate(".concat(targetStack.bbox.x + targetStack.bbox.width / 2 - 22, ", ").concat(_this.topLeft.y + _this.height + 45, ")\">\n                        <g>\n                            <circle fill=\"").concat(_this.taktColor, "\" r=\"8\"></circle>\n                            <path transform=\"translate(-2,-6)\" d=\"M1.91878 12L1.91162 11.9996C1.90912 11.9996 1.90697 12 1.90446 12C1.17203 12 0.578132 11.4065 0.578132 10.6737C0.578132 9.94159 1.17203 9.34805 1.90446 9.34805C1.90697 9.34805 1.90912 9.34805 1.91162 9.34805H1.91878C2.65086 9.34805 3.24547 9.94159 3.24547 10.6737C3.24547 11.4061 2.65194 12 1.91878 12ZM3.82076 1.89302C3.73412 3.21649 3.12913 7.15253 3.12913 7.15253C3.12913 7.81623 2.58535 8.35393 1.92165 8.35393C1.91807 8.35393 1.91449 8.35393 1.91127 8.35393C1.90804 8.35393 1.90411 8.35393 1.90088 8.35393C1.23754 8.35393 0.69376 7.81552 0.69376 7.15253C0.69376 7.15253 0.0891242 3.21649 0.00249192 1.89302C-0.0404662 1.23039 0.467156 0 1.90124 0C1.90482 0 1.9084 0.000358013 1.91162 0.000358013C1.91485 0.000358013 1.91843 0 1.92201 0C3.35573 0 3.86407 1.23039 3.82076 1.89302Z\" fill=\"white\"/>\n                        </g>\n                        <g transform=\"translate(15,-9)\">\n                            <rect fill=\"").concat(_this.taktColor, "\" rx=\"6\" width=\"64\" height=\"18\"></rect>\n                            <text transform=\"translate(32,11)\" class=\"jj-yamazumi-error-text\">limit reached</text>\n                        </g>\n                    </g>")).appendTo(layerNode);
                }
                var preview = V('path', {
                    'class': 'jj-yamazumi-preview-line',
                    'stroke': color,
                    'd': "M ".concat(-size / 2, " 0 h ").concat(size, " l ").concat(_this.taskDepth, " ").concat(-_this.taskDepth)
                });
                return preview.node;
            },
            validateMoving: function (data) {
                if (data.targetStack !== data.sourceStack) {
                    var totalDuration = data.targetStack.elements.reduce(function (agg, el) { return agg + el.get('duration'); }, 0);
                    if (totalDuration + data.sourceElement.get('duration') > _this.maxDuration) {
                        return false;
                    }
                }
                return true;
            }
        });
        this.layoutView.dragend = function (element, x, y) {
            ui.StackLayoutView.prototype.dragend.call(_this.layoutView, element, x, y);
            if (_this.invalidDurationElement) {
                _this.invalidDurationElement.remove();
                delete _this.invalidDurationElement;
            }
        };
        this.layoutView.model.on('update', function () {
            _this.layoutView.model.stacks.forEach(function (st, i) {
                st.elements.forEach(function (el, j) {
                    el.set('z', i * 100 + j);
                });
            });
        });
        // Update leyout when size of the taskElement is changed
        this.paper.model.on('change:size', function () { return _this.layoutView.model.update(); });
        this.drawTakt();
        this.drawYAxis();
        this.paper.on('element:mouseenter', function (view) {
            if (!(view.model instanceof TaskElement))
                return;
            _this.paper.removeTools();
            view.model.set('active', true);
            var color = view.model.get('topColor');
            var textColor = view.model.get('labelColor');
            var toolsView = new dia.ToolsView({
                tools: [
                    new elementTools.Boundary({
                        useModelGeometry: true,
                        padding: { bottom: -1 },
                        attributes: {
                            stroke: 'white',
                            fill: 'none'
                        }
                    }),
                    new elementTools.Button({
                        markup: util.svg /* xml */(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                            <circle @selector=\"button\" r=\"10\" fill=\"", "\" stroke-width=\"1\" stroke=\"white\" cursor=\"pointer\"/>\n                            <g transform=\"translate(-6,-5)\" opacity=\"0.5\" fill=\"", "\" cursor=\"pointer\">\n                                <path d=\"M2.46436 1.89331L3.01573 8.84843C3.06828 9.49816 3.61127 10.0088 4.23199 10.0073L7.41148 9.99977C8.0322 9.9983 8.571 9.48514 8.61824 8.83518L9.11473 1.87758L2.46436 1.89331ZM4.50373 9.10285C4.5103 9.2448 4.40298 9.35703 4.26526 9.35736C4.12754 9.35768 4.01132 9.24398 4.00276 9.10404L3.68711 3.17413C3.67634 2.9822 3.79945 2.82594 3.96112 2.82556C4.12279 2.82518 4.25915 2.98082 4.26792 3.17275L4.50373 9.10285ZM6.06853 9.09915C6.06911 9.24112 5.9558 9.35336 5.82008 9.35368C5.68435 9.354 5.57012 9.2403 5.56955 9.10033L5.50538 3.16983C5.5026 2.97788 5.6317 2.82161 5.79337 2.82122C5.95504 2.82084 6.08541 2.9765 6.0842 3.16846L6.06853 9.09915ZM7.63332 9.09545C7.62791 9.23743 7.51061 9.34968 7.37289 9.35001C7.23518 9.35033 7.12893 9.23661 7.13235 9.09663L7.31966 3.16553C7.32487 2.97357 7.46195 2.81728 7.62362 2.81689C7.78528 2.81651 7.90967 2.97218 7.90047 3.16416L7.63332 9.09545Z\"/>\n                                <path d=\"M9.57444 1.53931L2.00964 1.5573C1.97195 1.1327 2.22029 0.783907 2.56397 0.78309L9.01583 0.767744C9.3575 0.766931 9.60869 1.11655 9.57444 1.53931Z\"/>\n                                <path d=\"M7.15587 1.05864L4.42723 1.0651L4.4226 0.908938C4.40461 0.418442 4.71057 0.0112713 5.10609 0.0103352L6.47041 0.00710629C6.86392 0.00617496 7.17321 0.411889 7.16122 0.900454L7.15587 1.05864Z\"/>\n                            </g>\n                        "], [/* xml */ "\n                            <circle @selector=\"button\" r=\"10\" fill=\"", "\" stroke-width=\"1\" stroke=\"white\" cursor=\"pointer\"/>\n                            <g transform=\"translate(-6,-5)\" opacity=\"0.5\" fill=\"", "\" cursor=\"pointer\">\n                                <path d=\"M2.46436 1.89331L3.01573 8.84843C3.06828 9.49816 3.61127 10.0088 4.23199 10.0073L7.41148 9.99977C8.0322 9.9983 8.571 9.48514 8.61824 8.83518L9.11473 1.87758L2.46436 1.89331ZM4.50373 9.10285C4.5103 9.2448 4.40298 9.35703 4.26526 9.35736C4.12754 9.35768 4.01132 9.24398 4.00276 9.10404L3.68711 3.17413C3.67634 2.9822 3.79945 2.82594 3.96112 2.82556C4.12279 2.82518 4.25915 2.98082 4.26792 3.17275L4.50373 9.10285ZM6.06853 9.09915C6.06911 9.24112 5.9558 9.35336 5.82008 9.35368C5.68435 9.354 5.57012 9.2403 5.56955 9.10033L5.50538 3.16983C5.5026 2.97788 5.6317 2.82161 5.79337 2.82122C5.95504 2.82084 6.08541 2.9765 6.0842 3.16846L6.06853 9.09915ZM7.63332 9.09545C7.62791 9.23743 7.51061 9.34968 7.37289 9.35001C7.23518 9.35033 7.12893 9.23661 7.13235 9.09663L7.31966 3.16553C7.32487 2.97357 7.46195 2.81728 7.62362 2.81689C7.78528 2.81651 7.90967 2.97218 7.90047 3.16416L7.63332 9.09545Z\"/>\n                                <path d=\"M9.57444 1.53931L2.00964 1.5573C1.97195 1.1327 2.22029 0.783907 2.56397 0.78309L9.01583 0.767744C9.3575 0.766931 9.60869 1.11655 9.57444 1.53931Z\"/>\n                                <path d=\"M7.15587 1.05864L4.42723 1.0651L4.4226 0.908938C4.40461 0.418442 4.71057 0.0112713 5.10609 0.0103352L6.47041 0.00710629C6.86392 0.00617496 7.17321 0.411889 7.16122 0.900454L7.15587 1.05864Z\"/>\n                            </g>\n                        "])), color, textColor),
                        x: 0,
                        y: 0,
                        offset: {
                            x: 0,
                            y: 0
                        },
                        useModelGeometry: true,
                        action: function () {
                            _this.paper.model.removeCells([view.model]);
                            _this.layoutView.model.update();
                        }
                    }),
                    new DurationHandle({
                        durationHeight: _this.durationHeight,
                        maxDuration: _this.maxDuration,
                        minDuration: _this.minDuration,
                        layout: _this.layoutView,
                        color: color
                    })
                ]
            });
            view.addTools(toolsView);
        });
        this.paper.on('element:mouseleave', function (view) {
            if (!(view.model instanceof TaskElement))
                return;
            if (!view.model.get('focused')) {
                view.model.set('active', false);
            }
            view.model.set('hovered', false);
            view.removeTools();
        });
        this.paper.model.getCells().forEach(function (el) {
            if (el instanceof TaskElement) {
                DurationNumberInput.add(el.findView(_this.paper), 'front', 'duration-number-input', {
                    layoutView: _this.layoutView,
                    maxDuration: _this.maxDuration,
                    minDuration: _this.minDuration
                });
            }
        });
    }
    Yamazumi3D.prototype.createOperators = function () {
        var _this = this;
        var graph = this.paper.model;
        var bottomElement = new BottomElement({
            frontColor: '#C1CFDA',
            sideColor: '#BBBBBB',
            topColor: '#D8E0E6',
            depth: this.taskDepth,
            position: {
                x: this.topLeft.x + this.operationGap,
                y: this.topLeft.y + this.height
            },
            operators: this.operators,
            operationGap: this.operationGap,
            taskWidth: this.taskWidth
        });
        graph.addCell(bottomElement);
        this.operators.forEach(function (operator, operatorIndex) {
            var tasks = operator.tasks;
            tasks.forEach(function (task, taskIndex) {
                var taskElement = new TaskElement(__assign(__assign({}, task), { durationHeight: _this.durationHeight, stackIndex: operatorIndex, stackElementIndex: taskIndex, depth: _this.taskDepth }));
                graph.addCell(taskElement);
            });
        });
    };
    Yamazumi3D.prototype.drawYAxis = function () {
        var y = this.topLeft.y + this.height;
        var x = this.topLeft.x - this.legendOffset;
        var layerNode = this.paper.getLayerView(dia.Paper.Layers.BACK).el;
        var axis = V('g');
        var currentY = y;
        var duration = 0;
        while (currentY > this.topLeft.y) {
            V('path', {
                'class': 'jj-yamazumi-legend-line',
                'd': "M ".concat(x, " ").concat(currentY, " h 10")
            }).appendTo(axis);
            if (duration !== 0) {
                var textEl = V('text', {
                    'class': 'jj-yamazumi-legend-text',
                    'transform': "translate(".concat(x - 35, ", ").concat(currentY - 7, ")"),
                    'alignment-baseline': 'middle'
                });
                textEl.text("".concat(duration, " h"));
                textEl.appendTo(axis);
            }
            currentY -= this.durationHeight * 10;
            duration += 10;
        }
        V('path', {
            'class': 'jj-yamazumi-legend-line',
            'd': "M ".concat(x, " ").concat(y, " V ").concat(this.topLeft.y + this.height - this.maxDuration * this.durationHeight)
        }).appendTo(axis);
        axis.appendTo(layerNode);
        return axis;
    };
    Yamazumi3D.prototype.drawTakt = function () {
        var y = this.topLeft.y + this.taskDepth;
        var x = this.topLeft.x - this.legendOffset;
        var layerNode = this.paper.getLayerView(dia.Paper.Layers.FRONT).el;
        return V('path', {
            'class': 'jj-yamazumi-takt',
            'stroke': this.taktColor,
            'd': "M ".concat(x, " ").concat(y, " l ").concat(this.taskDepth, " ").concat(-this.taskDepth, " h ").concat(this.operators.length * this.taskWidth + this.operationGap + this.legendOffset + 10)
        }).appendTo(layerNode);
    };
    return Yamazumi3D;
}());
export { Yamazumi3D };
var templateObject_1;
